// src/com/dc_veh_ban_state/DcVehBanStateGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * DC_VEH_BAN_STATE Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-10-02 10:10:44 using DbdbTap
 ************************************************ */

const DC_VEH_BAN_STATE_LIST_PART = gql`
fragment DcVehBanStateListPart on DcVehBanState {
    vehInfoSeq
    dcCd
    vehBanFlag
    vehBanLastingFlag
    vehBanStartTime
    vehBanDays
    regDate
    regUser
}
`;


export const LIST_DC_VEH_BAN_STATE = gql`
${DC_VEH_BAN_STATE_LIST_PART}
query ListDcVehBanState {
    dcVehBanStateList {
        ...DcVehBanStateListPart
    }
}
`;

export const GET_DC_VEH_BAN_STATE = gql`
${DC_VEH_BAN_STATE_LIST_PART}
query GetDcVehBanState($vehInfoSeq:Int!) {
    dcVehBanStateItem(vehInfoSeq:$vehInfoSeq) {
        ...DcVehBanStateListPart
    }
}
`;

export const ADD_DC_VEH_BAN_STATE = gql`
mutation AddDcVehBanState($dcVehBanState:InputDcVehBanStateAdd!) {
	dcVehBanStateAdd(dcVehBanState: $dcVehBanState) {
		ok
		message
	}
}
`;

export const EDIT_DC_VEH_BAN_STATE = gql`
mutation EditDcVehBanState($dcVehBanState:InputDcVehBanStateEdit!) {
	dcVehBanStateEdit(dcVehBanState: $dcVehBanState) {
		ok
		message
	}
}
`;

export const REMOVE_DC_VEH_BAN_STATE = gql`
mutation RemoveDcVehBanState($dcVehBanState:InputDcVehBanStateRemove!) {
	dcVehBanStateRemove(dcVehBanState: $dcVehBanState) {
		ok
		message
	}
}
`;
